import "./LogoSlider.scss";
import Marquee from "react-fast-marquee";
import { motion } from "framer-motion";
import { baseUrl } from "../../../utils/apiData";

const LogoSlider = ({ dataList }) => {

  return (
    <section className="logo_slider p_b">
      <div className="content_wrap">
        <motion.p
          initial={{ translateY: 32, opacity: 0 }}
          whileInView={{ translateY: 0, opacity: 1 }}
          transition={{ duration: 0.6, ease: "easeInOut" }}
          viewport={{ once: true }}
          className="t_20 text-center"
        >
          <span></span>Our Partners<span></span>
        </motion.p>
        {dataList?.length > 0 ? (
          <Marquee>
            {[...dataList, ...dataList, ...dataList, ...dataList]?.map((item, k) => {
              return (
                <div className="logo_card" key={k}>
                  <img src={`${baseUrl}/${item}`} alt="Partner" />
                </div>
              );
            })}
          </Marquee>
        ) : (
          <p className="text-center">Data not found...</p>
        )}
      </div>
    </section>
  );
};
export default LogoSlider;
